<div class="apply-result">
    <div class="apply-result__header">
        <h2 class="apply-result__title">
            {{ TEXT.APPLY_RESULT_TITLE }}
            <span class="apply-result__dai" *ngIf="daiName">{{ daiName }}</span>
        </h2>
        <button (click)="close()" class="apply-result__close">{{ BUTTON.CLOSE }}</button>
    </div>

    <p class="apply-result__caution">{{ TEXT.APPLY_RESULT_CAUTION }}</p>

    <ul class="apply-result__legend">
        <li class="apply-result__legend-row" *ngFor="let row of legend">
            <span class="apply-result__legend-labels">
                <span *ngFor="let label of row.labels" [attr.data-tone]="label.tone">{{ label.text }}</span>
            </span>
            <span class="apply-result__legend-desc">{{ TEXT.APPLY_LEGEND_SEPARATOR }}{{ row.description }}</span>
        </li>
    </ul>

    <p class="apply-result__notice" *ngIf="view.planFailed">{{ planFailedMessage }}</p>
    <p class="apply-result__notice" *ngIf="view.daiNotFound">{{ TEXT.APPLY_RESULT_DAI_NOT_FOUND }}</p>

    <div class="apply-result__tabgroup" *ngIf="activeTab as tab" [attr.data-tone]="tab.tone">
    <div class="apply-result__tabs" role="tablist">
        <button *ngFor="let t of tabs"
                type="button"
                class="apply-result__tab"
                role="tab"
                [class.is-active]="t.key === activeTabKey"
                [attr.data-tone]="t.tone"
                [attr.aria-selected]="t.key === activeTabKey"
                (click)="select(t.key)">
            {{ t.label }}
        </button>
    </div>

    <div class="apply-result__panel" role="tabpanel">
        <p class="apply-result__hint" *ngIf="tab.needsCheck && tab.rows.length">{{ TEXT.APPLY_RESULT_CHECK_HINT }}</p>

        <p class="apply-result__empty" *ngIf="!tab.rows.length">{{ TEXT.APPLY_RESULT_EMPTY }}</p>

        <div class="apply-result__scroll" *ngIf="tab.rows.length">
        <table class="apply-result__table" [attr.data-tone]="tab.tone">
            <thead>
                <tr>
                    <th class="apply-result__th apply-result__th--room">{{ TEXT.APPLY_TABLE_ROOM_HEADER }}</th>
                    <th class="apply-result__th" *ngFor="let col of tab.columns" [attr.data-key]="col.key">
                        {{ col.label }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr class="apply-result__row" *ngFor="let row of tab.rows">
                    <th scope="row" class="apply-result__room">{{ roomLabel(row.roomName) }}</th>
                    <td class="apply-result__cell" *ngFor="let col of tab.columns" [attr.data-key]="col.key">
                        <ul class="apply-result__days" *ngIf="daysFor(row, col.key).length; else emptyCell">
                            <li *ngFor="let day of daysFor(row, col.key)">{{ day }}</li>
                        </ul>
                        <ng-template #emptyCell><span class="apply-result__dash">—</span></ng-template>
                    </td>
                </tr>
            </tbody>
        </table>
        </div>
    </div>
    </div>
</div>
